// extracted by mini-css-extract-plugin
export var backupIcon = "_mv-1";
export var image = "_mv-0";